import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.29 4.914 9.374 8.88V7.375a2.626 2.626 0 0 1 5.25 0v5.605l.465.383c.246-.465.41-1.011.41-1.613v-1.094c0-.355.273-.656.656-.656.356 0 .657.3.657.656v1.094a4.83 4.83 0 0 1-.657 2.434l4.32 3.418c.301.218.356.628.11.902a.604.604 0 0 1-.902.11L3.496 5.925a.604.604 0 0 1-.11-.903.604.604 0 0 1 .903-.109m8.366 11.621v.902h1.313c.355 0 .656.301.656.657 0 .383-.3.656-.656.656H10.03a.63.63 0 0 1-.656-.656c0-.356.273-.657.656-.657h1.313v-.902a4.814 4.814 0 0 1-4.156-4.785v-1.258l1.312 1.04v.218a3.49 3.49 0 0 0 3.5 3.5c.355 0 .71-.055 1.04-.137l1.175.93a5.2 5.2 0 0 1-1.559.492"
    }, null, -1)
  ]))]))
}
export default { render: render }